import { action, observable } from 'mobx';

class BasicQueryInputStore{
    @observable accessor value = "";

    @action.bound
    setValue(v) {
        this.value = v;
    }

    @action.bound
    reset() {
        this.value = "";
    }

    constructor() {
    }
}

export default BasicQueryInputStore;